import React, { lazy } from 'react'

import { EmbedProps } from '@/embed/embedService'

const EmbedSidebar = lazy(() => import('@/embed/components/EmbedSidebar'))

const LazyEmbedSidebar: React.FC<EmbedProps> = ({ accessToken }) => {
  return <EmbedSidebar accessToken={accessToken} />
}

export default LazyEmbedSidebar
